var _path, _path2, _circle, _g, _g2, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitOnMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 89,
    viewBox: "0 0 56 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0C15.0957 0 5.00233 10.0512 5 22.4085C5 39.1845 22.9711 54.0604 23.7342 54.6843C24.8094 55.5609 26.1547 56 27.5 56C28.1816 56 28.8632 55.8871 29.5114 55.6614L29.5269 55.656C30.1487 55.438 30.741 55.1133 31.2658 54.6843C31.6035 54.4091 35.2877 51.3594 39.3019 46.5981C44.3874 40.566 50 31.7849 50 22.4085C50 10.0512 39.9067 0 27.5 0ZM27.5 31.4092C22.2499 31.4092 17.9772 27.1543 17.9772 21.9253C17.9772 16.6949 22.2499 12.44 27.5 12.44C32.7524 12.44 37.0228 16.6949 37.0228 21.9253C37.0228 27.1543 32.7524 31.4092 27.5 31.4092Z",
    fill: "#B754E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22.4085C50 31.7849 44.3874 40.566 39.3019 46.5981C35.2877 51.3594 31.6035 54.4091 31.2658 54.6843C30.741 55.1133 30.1487 55.438 29.5269 55.656L29.5114 55.6614C28.8632 55.8871 28.1816 56 27.5 56V31.4092C32.7524 31.4092 37.0228 27.1543 37.0228 21.9253C37.0228 16.6949 32.7524 12.44 27.5 12.44V0C39.9067 0 50 10.0512 50 22.4085Z",
    fill: "#B448DA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 22.5,
    r: 15.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_682_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1667 18.8161V16.3334C34.1667 15.9654 33.8687 15.6667 33.5 15.6667C33.1313 15.6667 32.8333 15.9654 32.8333 16.3334V17.9107L29.3647 15.5701C28.232 14.8061 26.768 14.8061 25.6353 15.5701L20.9687 18.7194C20.0493 19.3401 19.5 20.3727 19.5 21.4827V27.6667C19.5 29.5047 20.9953 31.0001 22.8333 31.0001H24.1667C24.5353 31.0001 24.8333 30.7014 24.8333 30.3334V24.3334C24.8333 23.9661 25.132 23.6667 25.5 23.6667H29.5C29.868 23.6667 30.1667 23.9661 30.1667 24.3334V30.3334C30.1667 30.7014 30.4647 31.0001 30.8333 31.0001H32.1667C34.0047 31.0001 35.5 29.5047 35.5 27.6667V21.4827C35.5 20.4287 35.004 19.4441 34.1667 18.8161Z",
    fill: "#212538"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_682_419)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 57,
    r: 8,
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.0003,
    cy: 57.0001,
    r: 5.33333,
    fill: "#B448DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_682_419",
    x: 0,
    y: 33,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.282353 0 0 0 0 0.831373 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_682_419"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_682_419",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_682_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(19.5 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitOnMap);
export default __webpack_public_path__ + "static/media/unit_on_map.b80d8f0b38ff874ca4b2867246d96bf3.svg";
export { ForwardRef as ReactComponent };